import { useTranslation } from "react-i18next"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

/**
 * Deadlines on the new-case form: the required Sista anbudsdag and the optional
 * Sista dag för frågor. Both are shown in the case material and the hand-over
 * email; the questions deadline can be changed later in Setup.
 */
export function QuickStartDeadlineFields({
  submissionDeadline,
  onSubmissionDeadlineChange,
  showSubmissionRequired,
  questionsDeadline,
  onQuestionsDeadlineChange,
  showQuestionsInvalid = false,
  disabled = false,
}: {
  submissionDeadline: string
  onSubmissionDeadlineChange: (next: string) => void
  showSubmissionRequired: boolean
  questionsDeadline: string
  onQuestionsDeadlineChange: (next: string) => void
  showQuestionsInvalid?: boolean
  disabled?: boolean
}) {
  const { t } = useTranslation()
  return (
    <>
      <div className="space-y-1.5">
        <Label htmlFor="qs-deadline">{t("tender.quickStart.submissionDeadlineLabel")}</Label>
        <Input
          required
          aria-required="true"
          className="mx-px w-[calc(100%-2px)]"
          disabled={disabled}
          id="qs-deadline"
          type="date"
          value={submissionDeadline}
          onChange={(e) => onSubmissionDeadlineChange(e.target.value)}
        />
        <p className="text-muted-foreground text-xs">
          {t("tender.quickStart.submissionDeadlineHint")}
        </p>
        {showSubmissionRequired && (
          <p className="text-destructive text-xs">
            {t("tender.quickStart.submissionDeadlineRequired")}
          </p>
        )}
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="qs-questions-deadline">
          {t("tender.quickStart.questionsDeadlineLabel")}
        </Label>
        <Input
          className="mx-px w-[calc(100%-2px)]"
          disabled={disabled}
          id="qs-questions-deadline"
          type="date"
          value={questionsDeadline}
          onChange={(e) => onQuestionsDeadlineChange(e.target.value)}
        />
        <p className="text-muted-foreground text-xs">
          {t("tender.quickStart.questionsDeadlineHint")}
        </p>
        {showQuestionsInvalid && (
          <p className="text-destructive text-xs">
            {t("tender.quickStart.questionsDeadlineInvalid")}
          </p>
        )}
      </div>
    </>
  )
}
